<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 16:53:09
 * @LastEditTime: 2019-08-26 18:03:51
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="container">
       <div>
            <el-button type="primary" @click="add()" style="margin-bottom:10px;">创建活动</el-button>
       </div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="生产批次号:">
                <el-select v-model="form.level_id" placeholder="" clearable>
                    <el-option v-for=" i in storeList" :key="i.id" :label="i.lname"
                                :value="i.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="二维码编号:">
                <el-input v-model="form.dealer_sn" clearable placeholder="请输入二维码"></el-input>
            </el-form-item>
            <el-form-item label="关键词:">
                <el-input v-model="form.dealer_name" clearable placeholder="活动ID、活动主题、备注"></el-input>
            </el-form-item>
            <el-form-item label="状态:">
                <el-select v-model="form.status" placeholder="" clearable>
                    <el-option value="">全部</el-option>
                    <el-option value="1">未开始</el-option>
                    <el-option value="2">进行中</el-option>  
                    <el-option value="3">已结束</el-option>
                    <el-option value="3">已禁用</el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
           
        </el-form>
        <!--表格-->
        <el-table
                ref="multipleTable"
                :data="tableData"
                border
                stripe
                v-loading='loading'
                height="350"
                style="width: 100%">
            <el-table-column
                    label="活动编号"
                    width="140"
                    prop='dealer_sn'
                    fixed
            >
            </el-table-column>
            <el-table-column
                    prop="dealer_name"
                    label="活动主题"
                  
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="lname"
                    label="	活动起止时间"
              
                    show-overflow-tooltip>
            </el-table-column>
               <el-table-column
                    prop="address"
                    label="	状态"
                    
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="person"
                    label="	优先级"
                    show-overflow-tooltip el-icon-question
                    :render-header="renderHeader"
                    >
                
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="detail(scope.row)">详情</el-button>
                    <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="disables(scope.row,2)" v-if='scope.row.status!=2'>禁用</el-button>
                    <el-button type="text" size="small" @click="disables(scope.row,3)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
        <!--发货-->
        <deliverDialog
        v-if="deliverDialog"
        v-on:handleClose = 'deliverDialog = false'>
        </deliverDialog>
        <!--物流码明细-->
        <instockDetailDialog
                v-if="instockDetailDialogVisable"
                v-bind:detailData="stock_in_sn"
                v-on:handleClose = 'instockDetailDialogVisable = false'>
        </instockDetailDialog>


    </div>

</template>

<script>
    // import deliverDialog from './deliverDialog';
    // import instockDetailDialog from './instockDetail'
    export default {
        name: "next_leve",
        data() {
            return {
                loading:false,
                deliverDialog:false,
                form: {
                region_city:"",
                   region_province:"",
                   region_city:"",
                   region_country:"",
                   store_img:[]
                },
                storeList:[],
                tableData: [
                ],
                instockDetailDialogVisable:false,
                stock_in_sn:'',//查看明细传递的入库单号
               //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                dealerLevel:[]//经销商级别,
                , form1: {
                    from_sn: '',
                    dealer_name: '',
                    from_level_id: '',
                }
                ,countrys:[]
                ,provinces:[]
                ,citys:[]
                ,areas:[]
            }
        },
        methods:
            {   
                renderHeader (h,{column}) { 
                return h(
                  'div',
                  [ 
                    h('span', column.label),
                    h('i', {
                       class:'el-icon-question',
                       style:'margin-left:5px;'
                     })
                  ],
                 );
               },
                // 获取四级联动
                getcountry(){
                     this.$get('logistics_2','/vstore/dealer_pc/regionlist',{
                         type:1,
                         parent_id:""
                     }).then(res=>{
                        this.countrys=res.data
                           this.citys=[]
                        this.areas=[]
                        this.provinces=[]
                        }).catch(error=>{
                        })
                } ,
                 getStoreLevel() {
                this.$get('logistics_2','/vstore/dealer_pc/dealerlevel').then(res=>{
                        this.storeList=res.data
                        }).catch(error=>{
                        })
                },

                // 查看详情
                detail(data){
                    this.$router.push({
                        name:'dealerDetail',
                        query:{
                            id:data.id
                        }
                    })
                },
                edit(data){
                     this.$router.push({
                        name:'addDealer',
                        query:{
                            edit:data.id
                        }
                    })
                },
                 //选择经销商
                getDealerInfo(val) {
                    this.form1.from_sn = val.dealer_sn;
                    this.form1.dealer_name = val.dealer_name;
                },
                //请求列表数据
                onSearch(){
                    this.loading=true
                      let beginstr = '', endstr = '';
                    if (this.form.start) {
                        beginstr = this.moment(this.form.start).format("YYYY-MM-DD");
                    }
                    if (this.form.end) {
                        endstr = this.moment(this.form.end).format("YYYY-MM-DD");
                    }
                    this.$get('logistics_2','/vstore/dealer_pc/dealerlist', {
                        lang:'',
                        ...this.form,
                        per_page:this.pageSize,
                        page:this.pageNo,
                        start_time:beginstr,
                        end_time:endstr
                    }).then(res => {
                         this.loading=false
                        this.tableData = res.data.data;
                        this.totalSize = res.data.total;
                    }).catch(function (error) {
                        console.log(error);
                         this.loading=false

                    });
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.onSearch();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.onSearch();
                },
                //添加入库
                add() {
                    this.$router.push({
                        name: 'addDealer'
                    });

                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                //发货
                deliver(row){
                this.deliverDialog = true;
                },
                //删除
                disables(row,temp) {
                    if(temp=2){
                        this.$confirm('是否禁用该经销商?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                      
                          var  url = '/vstore/dealer_pc/setdealerstatus' 
                        this.$get('logistics_2',url, {
                            id:row.id,
                            status:temp
                        }).then(res => {
                            if(res.code==1){
                                 this.$message({
                                type: 'success',
                                message: '禁用成功!'
                            });
                                this.onSearch()
                            }
                           
                         
                        }).catch(function (error) {
                            console.log(error);
                        });

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消禁用'
                        });
                    });
                    }else{
                        this.$confirm('是否删除该经销商?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        var  url = '/vstore/dealer_pc/setdealerstatus' 
                        this.$get('logistics_2',url, {
                            id:row.id,
                            status:temp
                        }).then(res => {
                            if(res.code==1){
                                 this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                                this.onSearch()
                            }
                      
                         
                        }).catch(function (error) {
                            console.log(error);
                        });

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                    }
                    

                }

            },
        created() {
            this.onSearch();
            this.getStoreLevel()
            this.getcountry()
        },
        components:{
            // deliverDialog,instockDetailDialog
        }
    }
</script>
<style lang="scss" scoped>


</style>